import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useQuoteContentSmallStyles = createStyles(({ token }) => ({
  quoteContentSmall: {
    marginTop: ThemeSpaces.SPACE_NORM_15,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontSize: token.fontSizeSM,

    [`@media (min-width: ${token.screenMDMin}px)`]: {
      fontSize: token.fontSize,
    },

    '.MapCard': {
      height: 240,
    },
  },
  // `&&` self-doubles so this outranks ShipmentDetails.styles.js's base
  // `.ShipmentDetailsTitle` rule (equal specificity otherwise, since the
  // original compound selector had one extra class).
  quoteContentLg: {
    '&&': {
      fontFamily: token.fontFamily,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      fontWeight: 500,
      lineHeight: '16px',

      '.ShipmentDetailsTitle': {
        marginTop: ThemeSpaces.SPACE_NORM0_5,
        color: ThemeColors.COLOR_GREY_BLUISH,
        fontFamily: token.fontFamily,
        fontSize: ThemeFont.FONT_SIZE_XS,
        fontWeight: 500,
        lineHeight: 1,
      },
    },
  },
  // Applied directly to ShipmentDetailsLg's own title (ShipmentDetails.jsx) —
  // it's only ever rendered from here, always in the `lg` branch, so the
  // override is unconditional. `&&` outranks the shared `shipmentInfoTitle`
  // base class also applied there.
  shipmentDetailsLgTitle: {
    '&&': {
      marginTop: ThemeSpaces.SPACE_NORM0_5,
      marginBottom: ThemeSpaces.SPACE_NORM0_5,
      fontSize: token.fontSizeHeading3,
    },
  },
  shipmentDetailsDeliveryCol: {
    [`@media (max-width: ${token.screenSMMax}px)`]: {
      paddingLeft: ThemeSpaces.SPACE_NORM,
    },
  },
}));
